// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IPriceForMobileSite {
  /** Валюта **/
  currency: ECurrency;
  /** Цена, число **/
  value: number;
  /** Сутки, месяц **/
  period?: TPriceForMobileSite_Period;
}

export enum ECurrency {
  /** € **/
  'Eur' = 'eur',
  /** ₽ **/
  'Rur' = 'rur',
  /** $ **/
  'Usd' = 'usd',
}
export type TPriceForMobileSite_Period = null | EPeriod;

export enum EPeriod {
  /** В сутки **/
  'Day' = 'day',
  /** В месяц **/
  'Month' = 'month',
}
